import React, { useState } from 'react';

const FileManager = ({ fs, setFs, onOpenFile }) => {
  const [currentPath, setCurrentPath] = useState('/home/visitor');

  // Helper to traverse the FS tree
  const getNodeByPath = (path) => {
    const parts = path.split('/').filter(Boolean);
    let node = fs;
    for (const part of parts) {
      if (!node.children || !node.children[part]) return null;
      node = node.children[part];
    }
    return node;
  };

  const currentNode = getNodeByPath(currentPath);

  // Derive folders and files from the current node
  const folders = [];
  const files = [];

  if (currentNode && currentNode.children) {
    Object.entries(currentNode.children).forEach(([name, node]) => {
      if (node.type === 'dir') {
        folders.push(name);
      } else {
        // Determine icon and type based on name/extension
        let icon = '📄';
        let type = 'text';

        if (name.endsWith('.txt')) {
          icon = '📝';
          type = 'text';
        } else if (name.endsWith('.md')) {
          icon = '📋';
          type = 'markdown';
        } else if (name.startsWith('.')) {
          icon = '⚙️';
          type = 'config';
        } else if (name === 'encrypted.txt') {
          icon = '🔐';
        }

        files.push({ name, icon, type });
      }
    });
  }

  const navigateToFolder = (folderName) => {
    setCurrentPath(`${currentPath === '/' ? '' : currentPath}/${folderName}`);
  };

  const goBack = () => {
    if (currentPath === '/') return;
    const parts = currentPath.split('/').filter(Boolean);
    parts.pop();
    setCurrentPath(parts.length === 0 ? '/' : '/' + parts.join('/'));
  };

  const openFile = (file) => {
    const node = currentNode.children[file.name];
    if (node && onOpenFile) {
      onOpenFile(file.name, node.content);
    }
  };

  return (
    <div className="file-manager">
      {/* Navigation Bar */}
      <div className="fm-navbar">
        <button className="fm-back-btn" onClick={goBack} disabled={currentPath === '/'}>
          ← Back
        </button>
        <div className="fm-path">{currentPath}</div>
      </div>

      {/* File Grid */}
      <div className="fm-content">
        {/* Folders - filter out hidden ones */}
        {folders
          .filter(folder => !folder.startsWith('.'))
          .map((folder, index) => (
            <div
              key={`folder-${index}`}
              className="fm-item fm-folder"
              onDoubleClick={() => navigateToFolder(folder)}
            >
              <div className="fm-icon">📁</div>
              <div className="fm-name">{folder}</div>
            </div>
          ))}

        {/* Files - filter out hidden ones */}
        {files
          .filter(file => !file.name.startsWith('.'))
          .map((file, index) => (
            <div
              key={`file-${index}`}
              className="fm-item fm-file"
              onDoubleClick={() => openFile(file)}
            >
              <div className="fm-icon">{file.icon}</div>
              <div className="fm-name">{file.name}</div>
            </div>
          ))}
          
        {/* Empty State */}
        {folders.length === 0 && files.length === 0 && (
          <div style={{ color: '#64748b', fontStyle: 'italic', padding: '20px' }}>
            Empty directory
          </div>
        )}
      </div>

      {/* Status Bar */}
      <div className="fm-statusbar">
        {folders.length} folders, {files.length} files
      </div>
    </div>
  );
};

export default FileManager;
